import { useContext } from "react";
import { PageContext } from "@utils/PageContext";

export const usePage = () => useContext(PageContext);
